"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUnserializableConstructors = hasUnserializableConstructors;
exports.isUnserializableConstructor = isUnserializableConstructor;
exports.setLoggableDetailHandlers = setLoggableDetailHandlers;
exports.setUnserializableConstructorList = setUnserializableConstructorList;
exports.useLoggableDetailHandlers = useLoggableDetailHandlers;
// eslint-disable-next-line @typescript-eslint/ban-types

let ignoreConstructorList = [];
let loggableDetailHandlers = [];

/**
 * Allows a bespoke set of loggable detail handlers to be used.
 * If you need to append or prepend to the existing ones, these are found in 'defaultLoggableDetailHandlers'.
 * @param handlers an array of handlers, invoked in order until one returns a truthy value.
 */
function setLoggableDetailHandlers(handlers) {
  loggableDetailHandlers = Object.freeze([...handlers]);
}
function useLoggableDetailHandlers(detail, includeStack) {
  const len = loggableDetailHandlers.length;
  for (let i = 0; i < len; i++) {
    const result = loggableDetailHandlers[i](detail, includeStack);
    if (result) {
      return result;
    }
  }
  return undefined;
}

/**
 * If an object type cannot be serialized, adding it to this list will exclude from
 * logging output.
 * @param constructors a list of Object constructors that cannot be serialized.
 */
function setUnserializableConstructorList(constructors) {
  ignoreConstructorList = Object.freeze([...constructors]);
}
function isUnserializableConstructor(ctor) {
  return ignoreConstructorList.indexOf(ctor) >= 0;
}
function hasUnserializableConstructors() {
  return ignoreConstructorList.length > 0;
}